import { apiHelper } from '@/util'
import { SHARED } from '@/constants/constants'

export const announcementService = {
  getAnnouncementListing,
  getAnnouncement,
  getPopupListing,
  getLoginPopupListing,
  getPaymentAnnouncement
}

//API URLs
const ANNOUNCEMENT = {
  ANNOUNCEMENT: '/announcement'
}

function getLoginPopupListing(filter) {
  const requestOptions = {
      params: {
          site: filter.site,
          type: filter.type,
          size: filter.itemsPerPage,
          page: filter.page,
          currency: SHARED.DEFAULT_CURRENCY,
          memberCode: filter.memberCode
      }
  }
  return apiHelper().get(`${ANNOUNCEMENT.ANNOUNCEMENT}`, requestOptions)
}

function getPopupListing(filter){
  const requestOptions = {
    params: {
      site: filter.site,
      type: filter.type,
      currency: SHARED.DEFAULT_CURRENCY,
      size: filter.itemsPerPage,
      page: filter.page
    }
  }
  return apiHelper().get(`${ANNOUNCEMENT.ANNOUNCEMENT}`, requestOptions)
}


function getAnnouncementListing(filter) {
  const requestOptions = {
    params: {
      site: filter.site,
      type: filter.type,
      currency: SHARED.DEFAULT_CURRENCY,
      size: filter.itemsPerPage,
      page: filter.page,
      memberCode: filter.memberCode
    }
  }
  return apiHelper().get(`${ANNOUNCEMENT.ANNOUNCEMENT}`, requestOptions)
}

function getAnnouncement(processedData, id) {
  const requestOptions = {
    params: {
      site: processedData.site,
      type: processedData.type,
      currency: SHARED.DEFAULT_CURRENCY
    }
  }
  return apiHelper().get(`${ANNOUNCEMENT.ANNOUNCEMENT}/${id}`, requestOptions)
}

function getPaymentAnnouncement(processedData, id) {
  const requestOptions = {
    params: {
      site: processedData.site,
      type: processedData.type,
      currency: SHARED.DEFAULT_CURRENCY
    }
  }
  return apiHelper().get(`${ANNOUNCEMENT.ANNOUNCEMENT}/${id}`, requestOptions)
}


